import BlurImageBackground from "@/components/BlurImageBackground";
import ButtonMultiClick from "@/components/Buttons/ButtonMultiClick";
import { FavoriteButton, ShareButton } from "@/components/Buttons/index";
import TitleMetaTags from "@/components/MetaTags/TitleMetaTags";
import TvShowRecommend from "@/components/Rtoaster/TvShowRecommend";
import TabMenu from "@/components/TabMenu";
import TitleDetailModal from "@/components/TitleDetailModal";
import TvShowEpisodesList from "@/components/TvShowEpisodesList";
import { useBreadcrumbs, useModal, useTitleQuery } from "@/hooks";
import config, { getStoreId } from "@/lib/config";
import isShowValuePlanLabel from "@/lib/isShowValuePlanLabel";
import routes from "@/lib/routes";
import contentsStyles from "@/styles/Contents.module.scss";
import styles from "@/styles/Title.module.scss";
import Image from "next/legacy/image";
import Link from "next/link";
import { useRouter } from "next/router";
import { useCallback, useEffect, useMemo } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var __N_SSP = true;
export default function Title() {
  var _title$bookmark, _title$bookmark2, _title$channel;
  const router = useRouter();
  const id = Number(router.query.id);
  const hash = window.location.hash.substring(1);
  const {
    showModal
  } = useModal();
  const {
    setBreadcrumbs
  } = useBreadcrumbs();
  const {
    data
  } = useTitleQuery({
    variables: {
      id,
      withBookmark: true,
      withCourse: true
    }
  });
  const title = data === null || data === void 0 ? void 0 : data.title;
  const bookmarkMeta = title === null || title === void 0 || (_title$bookmark = title.bookmark) === null || _title$bookmark === void 0 ? void 0 : _title$bookmark.bookmark_meta;
  const bookmarkPosition = (title === null || title === void 0 || (_title$bookmark2 = title.bookmark) === null || _title$bookmark2 === void 0 ? void 0 : _title$bookmark2.position) || 0;
  const channelId = Number(title === null || title === void 0 || (_title$channel = title.channel) === null || _title$channel === void 0 ? void 0 : _title$channel.id);
  const showValuePlanLabel = isShowValuePlanLabel({
    channelId
  });
  const selectMenu = useMemo(() => {
    if (hash === "recommend") {
      return "recommend";
    } else {
      return "episodes";
    }
  }, [hash]);
  const progress = useMemo(() => {
    if (bookmarkMeta) {
      return bookmarkPosition / bookmarkMeta.duration * 100;
    } else {
      return 0;
    }
  }, [bookmarkMeta, bookmarkPosition]);
  const tabMenus = [{
    text: "エピソード一覧",
    key: "episodes",
    link: {
      href: routes.title(id),
      shallow: true,
      matchtype: "partial",
      ignore: routes.titleRecommend(id)
    }
  }, {
    text: "おすすめ一覧",
    key: "recommend",
    link: {
      href: routes.titleRecommend(id),
      shallow: true
    }
  }];
  const handleClick = useCallback(() => {
    showModal( /*#__PURE__*/_jsx(TitleDetailModal, {
      title: title
    }), {
      style: "full"
    });
  }, [title]);
  useEffect(() => {
    var _title$channel2;
    const storeId = getStoreId();
    const valuePlanId = config.valuePlanId.vod;
    const breadcrumbs = [{
      text: "ホーム",
      href: routes.home
    }];
    if (storeId == parseInt(title === null || title === void 0 || (_title$channel2 = title.channel) === null || _title$channel2 === void 0 ? void 0 : _title$channel2.id, 10)) {
      breadcrumbs.push({
        text: "単品商品",
        href: routes.store
      });
    } else if (title !== null && title !== void 0 && title.channel) {
      const channelId = parseInt(title.channel.id, 10);
      if (valuePlanId === channelId) {
        breadcrumbs.push({
          text: config.valuePlan.text,
          href: routes.valuePlan
        });
      } else {
        breadcrumbs.push({
          text: "月額商品一覧",
          href: routes.channels
        });
        breadcrumbs.push({
          text: title.channel.name,
          href: routes.channelDetail(channelId)
        });
      }
    }
    breadcrumbs.push({
      text: title.name
    });
    setBreadcrumbs(breadcrumbs);
  }, [title]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(TitleMetaTags, {
      title: title
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.container,
      children: [/*#__PURE__*/_jsx("div", {
        className: styles.title,
        children: /*#__PURE__*/_jsx(BlurImageBackground, {
          className: "title",
          item: title,
          children: /*#__PURE__*/_jsxs("div", {
            className: styles.content,
            children: [/*#__PURE__*/_jsxs("div", {
              className: styles.info,
              children: [/*#__PURE__*/_jsx("h1", {
                className: styles.title,
                children: title.name
              }), /*#__PURE__*/_jsx("p", {
                className: styles.description,
                children: title.description
              }), /*#__PURE__*/_jsxs("div", {
                className: styles.buttons,
                children: [/*#__PURE__*/_jsx(ButtonMultiClick, {
                  borderLight: true,
                  medium: true,
                  onClick: handleClick,
                  children: "\u8A73\u7D30\u3092\u898B\u308B"
                }), /*#__PURE__*/_jsx(FavoriteButton, {
                  borderLight: true,
                  transparent: true,
                  metaId: title.id
                }), /*#__PURE__*/_jsx(ShareButton, {
                  borderLight: true,
                  transparent: true,
                  title: title.name
                })]
              }), bookmarkMeta && /*#__PURE__*/_jsx(Link, {
                href: routes.watch(bookmarkMeta.id),
                children: /*#__PURE__*/_jsxs("div", {
                  className: styles.bookmark,
                  children: [/*#__PURE__*/_jsxs("div", {
                    className: styles.artwork,
                    children: [/*#__PURE__*/_jsxs("div", {
                      className: styles.inner,
                      children: [!!(bookmarkMeta !== null && bookmarkMeta !== void 0 && bookmarkMeta.thumbnailUrl) && /*#__PURE__*/_jsx(Image, {
                        src: bookmarkMeta.thumbnailUrl,
                        alt: bookmarkMeta.name,
                        layout: "fill",
                        objectFit: "contain"
                      }), showValuePlanLabel && /*#__PURE__*/_jsx("div", {
                        className: styles.valueplanLabel,
                        children: /*#__PURE__*/_jsx(Image, {
                          src: "/images/valueplan_label.png",
                          alt: "valueplan_label",
                          layout: "fill",
                          objectFit: "cover"
                        })
                      })]
                    }), /*#__PURE__*/_jsx("span", {
                      className: styles.progressbar,
                      children: /*#__PURE__*/_jsx("span", {
                        className: styles["progressbar-inner"],
                        style: {
                          width: `${progress}%`
                        }
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("div", {
                    className: styles.bookmarkTitle,
                    children: [/*#__PURE__*/_jsx("span", {
                      title: bookmarkMeta.name,
                      children: bookmarkMeta.name
                    }), /*#__PURE__*/_jsxs("span", {
                      children: [bookmarkPosition > 0 && "続きから", "\u518D\u751F\u3059\u308B"]
                    })]
                  })]
                })
              })]
            }), /*#__PURE__*/_jsx("div", {
              className: styles.artwork,
              children: /*#__PURE__*/_jsxs("div", {
                className: styles.inner,
                children: [!!title.thumbnailUrl && /*#__PURE__*/_jsx(Image, {
                  src: title.thumbnailUrl,
                  alt: title.name,
                  layout: "fill",
                  objectFit: "contain"
                }), showValuePlanLabel && /*#__PURE__*/_jsxs(_Fragment, {
                  children: [/*#__PURE__*/_jsx("div", {
                    className: styles.valueplanLabel,
                    children: /*#__PURE__*/_jsx(Image, {
                      src: "/images/valueplan_label.png",
                      alt: "valueplan_label",
                      layout: "fill",
                      objectFit: "cover"
                    })
                  }), /*#__PURE__*/_jsx("div", {
                    className: styles.leminoLogo,
                    children: /*#__PURE__*/_jsx(Image, {
                      src: "/images/lemino_logo.png",
                      alt: "lemino_logo",
                      layout: "fill",
                      objectFit: "contain"
                    })
                  })]
                })]
              })
            })]
          })
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: contentsStyles.container,
        children: [/*#__PURE__*/_jsx("nav", {
          children: /*#__PURE__*/_jsx(TabMenu, {
            menus: tabMenus
          })
        }), /*#__PURE__*/_jsxs("div", {
          children: [selectMenu === "episodes" && /*#__PURE__*/_jsx(TvShowEpisodesList, {
            id: id
          }), selectMenu === "recommend" && /*#__PURE__*/_jsx(TvShowRecommend, {
            id: id
          })]
        })]
      })]
    })]
  });
}